module.exports = ".content{display:flex;flex-direction:column}.mat-checkbox{margin-bottom:20px;margin-top:10px}\n"